import React from 'react';
import { toLower } from 'lodash';
import {
  FilterContainer,
  FilterSearchButton,
  FilterTitle,
  FilterWrapper,
} from './styles/VenuesFilter.styled';
import VenuesFilterSelect from './VenuesFilterSelect';

export default function VenuesFilterBar({ data, dir, setVenueType }) {
  const isArabic = dir === 'rtl';

  const handleOptionsList = (list) =>
    list.map((item) => ({
      label: item,
      value: toLower(item),
    }));

  const eventsConf = {
    isArabic,
    onChange: (value) => setVenueType(value),
    options: handleOptionsList(data.eventTypes),
    placeholder: data.eventTypes[0],
  };

  const participantsConf = {
    isArabic,
    options: handleOptionsList(data.participantsQty),
    placeholder: data.participantsQty[0],
  };

  return (
    <FilterWrapper isArabic={isArabic}>
      <FilterContainer isArabic={isArabic}>
        <FilterTitle isArabic={isArabic} dir={dir}>
          {data.title}
        </FilterTitle>
        <VenuesFilterSelect isArabic={isArabic} data={eventsConf} />
        <VenuesFilterSelect isArabic={isArabic} data={participantsConf} />
        <FilterSearchButton isArabic={isArabic}>{isArabic ? 'إبحث' : 'Search'}</FilterSearchButton>
      </FilterContainer>
    </FilterWrapper>
  );
}
